/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : licenseUtil.ts
// 설명 : 라이선스 상태(프론트) - 라이선스 3단계(2026-09-27)
//  - 로그인 후 메뉴트리(apiMainMenuTree) 응답의 license.readOnly를 mainFrame이 저장(setLicenseReadOnly)하고,
//    NaviMenuBar가 읽어서(isLicenseReadOnly) 저장/삭제/신규/복사/행편집 버튼을 비활성으로 보여줌.
//  - 읽기 전용 = 라이선스가 만료되고 유예기간도 지났으며 만료처리가 READONLY인 상태. 실제 차단은 서버(licenseRequestGuard)가 함 -
//    이 값은 화면 표시용(조작해도 서버가 저장 요청을 거부함).
/////////////////////////////////////////////////////////////////////////////////////////////////////////
const KEY = 'licenseReadOnly';

export function setLicenseReadOnly(readOnly: boolean): void {
  try { localStorage.setItem(KEY, readOnly ? 'Y' : 'N'); } catch { /* 저장소 접근 실패는 무시 */ }
}

export function isLicenseReadOnly(): boolean {
  try { return localStorage.getItem(KEY) === 'Y'; } catch { return false; }
}
